module.exports = {
  'STATE_ERROR': 'error',
  'STATE_WAITING': 'waiting',
  'STATE_PREPROCESSING': 'preprocessing',
  'STATE_UPLOADING': 'uploading',
  'STATE_POSTPROCESSING': 'postprocessing',
  'STATE_COMPLETE': 'complete'
};
//# sourceMappingURL=StatusBarStates.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/uppy/lib/plugins/StatusBar/StatusBarStates.js
// module id = 385
// module chunks = 0